import {
    INTEGRATION_GET_PUBLICATIONS_BEGIN,
    INTEGRATION_GET_PUBLICATIONS_SUCCESS,
    INTEGRATION_GET_PUBLICATIONS_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function getPublications(catalogId, stockId, is0Km) {
    return async dispatch => {
        dispatch({
            type: INTEGRATION_GET_PUBLICATIONS_BEGIN
        })

        try {
            const { data: { data } }  = await BFFAgent.Integrations.getPublications(catalogId, stockId, is0Km)
            // TODO: check if this call should be here or where
            BFFAgent.Catalogs.syncSalesChannel(catalogId)
            
            dispatch({
                type: INTEGRATION_GET_PUBLICATIONS_SUCCESS,
                data,
            })
        } catch (error) {
            console.error(error)
            dispatch({
                type: INTEGRATION_GET_PUBLICATIONS_FAILURE
            })
        }
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_GET_PUBLICATIONS_BEGIN:
            return {
                ...state,
                publicationsPending: true
            }

        case INTEGRATION_GET_PUBLICATIONS_SUCCESS:
            return {
                ...state,
                publications: action.data,
                publicationsPending: false
            }

        case INTEGRATION_GET_PUBLICATIONS_FAILURE:
            return {
                ...state,
                publicationsPending: false
            }

        default:
            return state
    }
}
